const SampleHistoryData = {
	1596275439 : {
		Encounter : {
			encdps : 0,
			enchps : 0,
			enctps : 0,
		},
	},
	1596275454 : {
		Encounter : {
			encdps : 11821.2,
			enchps : 1093.67,
			enctps : 397.07,
		},
		"Hattori Hanzo" : {
			encdps : 2243.47,
			enchps : 0,
			enctps : 0,
		},
		Beedle : {
			encdps : 2085.6,
			enchps : 0,
			enctps : 0,
		},
		YOU : {
			encdps : 1891.53,
			enchps : 0,
			enctps : 0,
		},
		Uther : {
			encdps : 1700.33,
			enchps : 0,
			enctps : 327.67,
		},
		"Lindsey Stirling" : {
			encdps : 1518.4,
			enchps : 0,
			enctps : 0,
		},
		Ashor : {
			encdps : 1365.33,
			enchps : 155,
			enctps : 69.4,
		},
		"Sigmund Freud" : {
			encdps : 1016.53,
			enchps : 241.53,
			enctps : 0,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 697.13,
			enctps : 0,
		},
	},
	1596275469 : {
		Encounter : {
			encdps : 13106,
			enchps : 1321.4,
			enctps : 307.9,
		},
		"Hattori Hanzo" : {
			encdps : 2561.63,
			enchps : 0,
			enctps : 0,
		},
		YOU : {
			encdps : 2054.6,
			enchps : 0,
			enctps : 0,
		},
		Uther : {
			encdps : 1917.07,
			enchps : 0,
			enctps : 219.23,
		},
		Beedle : {
			encdps : 1832.87,
			enchps : 0,
			enctps : 9.33,
		},
		"Lindsey Stirling" : {
			encdps : 1769.63,
			enchps : 0,
			enctps : 0,
		},
		Ashor : {
			encdps : 1711.77,
			enchps : 377.8,
			enctps : 69.27,
		},
		"Sigmund Freud" : {
			encdps : 1258.43,
			enchps : 193.53,
			enctps : 10.07,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 750.07,
			enctps : 0,
		},
	},
	1596275484 : {
		Encounter : {
			encdps : 12060.13,
			enchps : 1758.76,
			enctps : 672.76,
		},
		YOU : {
			encdps : 2409.16,
			enchps : 0,
			enctps : 76.91,
		},
		"Hattori Hanzo" : {
			encdps : 2375.62,
			enchps : 0,
			enctps : 72.84,
		},
		Uther : {
			encdps : 1719.2,
			enchps : 0,
			enctps : 146.16,
		},
		Beedle : {
			encdps : 1670.6,
			enchps : 0,
			enctps : 12.53,
		},
		"Lindsey Stirling" : {
			encdps : 1599.91,
			enchps : 0,
			enctps : 6.2,
		},
		Ashor : {
			encdps : 1429.04,
			enchps : 301.44,
			enctps : 46.18,
		},
		"Sigmund Freud" : {
			encdps : 856.6,
			enchps : 260.69,
			enctps : 81.38,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1196.62,
			enctps : 230.56,
		},
	},
	1596275499 : {
		Encounter : {
			encdps : 11251.5,
			enchps : 2105.43,
			enctps : 995.35,
		},
		YOU : {
			encdps : 2178.38,
			enchps : 0,
			enctps : 123.43,
		},
		"Hattori Hanzo" : {
			encdps : 2170.63,
			enchps : 0,
			enctps : 117.17,
		},
		Uther : {
			encdps : 1597.93,
			enchps : 0,
			enctps : 180.83,
		},
		Beedle : {
			encdps : 1588.87,
			enchps : 0,
			enctps : 46.47,
		},
		"Lindsey Stirling" : {
			encdps : 1551.52,
			enchps : 0,
			enctps : 44.23,
		},
		Ashor : {
			encdps : 1349.32,
			enchps : 264.33,
			enctps : 193.53,
		},
		"Sigmund Freud" : {
			encdps : 814.85,
			enchps : 304.77,
			enctps : 81.92,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1536.33,
			enctps : 207.77,
		},
	},
	1596275514 : {
		Encounter : {
			encdps : 10928.85,
			enchps : 2103.95,
			enctps : 1138.6,
		},
		"Hattori Hanzo" : {
			encdps : 2120.44,
			enchps : 0,
			enctps : 149.71,
		},
		YOU : {
			encdps : 2082.55,
			enchps : 0,
			enctps : 154.56,
		},
		Uther : {
			encdps : 1563.25,
			enchps : 0,
			enctps : 148.63,
		},
		"Lindsey Stirling" : {
			encdps : 1524.34,
			enchps : 0,
			enctps : 91.42,
		},
		Beedle : {
			encdps : 1511.67,
			enchps : 0,
			enctps : 93.6,
		},
		Ashor : {
			encdps : 1317.27,
			enchps : 280.58,
			enctps : 159.07,
		},
		"Sigmund Freud" : {
			encdps : 809.33,
			enchps : 360.21,
			enctps : 120.22,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1463.16,
			enctps : 221.38,
		},
	},
	1596275529 : {
		Encounter : {
			encdps : 10928.85,
			enchps : 2543.04,
			enctps : 1139.45,
		},
		"Hattori Hanzo" : {
			encdps : 2120.44,
			enchps : 0,
			enctps : 149.71,
		},
		YOU : {
			encdps : 2082.55,
			enchps : 0,
			enctps : 154.56,
		},
		Uther : {
			encdps : 1563.25,
			enchps : 0,
			enctps : 148.63,
		},
		"Lindsey Stirling" : {
			encdps : 1524.34,
			enchps : 0,
			enctps : 91.42,
		},
		Beedle : {
			encdps : 1511.67,
			enchps : 0,
			enctps : 93.6,
		},
		Ashor : {
			encdps : 1317.27,
			enchps : 280.58,
			enctps : 159.07,
		},
		"Sigmund Freud" : {
			encdps : 809.33,
			enchps : 441.03,
			enctps : 120.22,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1821.44,
			enctps : 222.23,
		},
	},
	1596275544 : {
		Encounter : {
			encdps : 7697.79,
			enchps : 1893.27,
			enctps : 1066.08,
		},
		"Hattori Hanzo" : {
			encdps : 1474.21,
			enchps : 0,
			enctps : 122.71,
		},
		YOU : {
			encdps : 1447.87,
			enchps : 0,
			enctps : 152.94,
		},
		"Lindsey Stirling" : {
			encdps : 1100.61,
			enchps : 0,
			enctps : 86.12,
		},
		Uther : {
			encdps : 1094.18,
			enchps : 0,
			enctps : 125.82,
		},
		Beedle : {
			encdps : 1085.64,
			enchps : 0,
			enctps : 126.9,
		},
		Ashor : {
			encdps : 932.61,
			enchps : 195.07,
			enctps : 141.13,
		},
		"Sigmund Freud" : {
			encdps : 562.68,
			enchps : 369.74,
			enctps : 97.38,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1328.46,
			enctps : 213.07,
		},
	},
	1596275559 : {
		Encounter : {
			encdps : 7835.57,
			enchps : 2068.38,
			enctps : 965.01,
		},
		YOU : {
			encdps : 1511.53,
			enchps : 0,
			enctps : 138.45,
		},
		"Hattori Hanzo" : {
			encdps : 1388.29,
			enchps : 0,
			enctps : 112.11,
		},
		"Lindsey Stirling" : {
			encdps : 1226.93,
			enchps : 0,
			enctps : 79.98,
		},
		Beedle : {
			encdps : 1127.8,
			enchps : 0,
			enctps : 114.8,
		},
		Uther : {
			encdps : 1084.84,
			enchps : 0,
			enctps : 112.42,
		},
		Ashor : {
			encdps : 974.01,
			enchps : 219.03,
			enctps : 125.83,
		},
		"Sigmund Freud" : {
			encdps : 522.17,
			enchps : 643.61,
			enctps : 90.03,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1205.74,
			enctps : 191.38,
		},
	},
	1596275574 : {
		Encounter : {
			encdps : 7458.24,
			enchps : 2101.67,
			enctps : 863.83,
		},
		YOU : {
			encdps : 1399.76,
			enchps : 0,
			enctps : 122.16,
		},
		"Hattori Hanzo" : {
			encdps : 1351.88,
			enchps : 0,
			enctps : 98.92,
		},
		"Lindsey Stirling" : {
			encdps : 1185.87,
			enchps : 0,
			enctps : 70.57,
		},
		Beedle : {
			encdps : 1081.47,
			enchps : 0,
			enctps : 101.29,
		},
		Uther : {
			encdps : 1019.51,
			enchps : 0,
			enctps : 99.2,
		},
		Ashor : {
			encdps : 917.96,
			enchps : 193.26,
			enctps : 123.38,
		},
		"Sigmund Freud" : {
			encdps : 501.79,
			enchps : 769.11,
			enctps : 79.44,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1139.3,
			enctps : 168.87,
		},
	},
	1596275589 : {
		Encounter : {
			encdps : 7834.7,
			enchps : 2041.31,
			enctps : 926.31,
		},
		YOU : {
			encdps : 1500.48,
			enchps : 0,
			enctps : 124.27,
		},
		"Hattori Hanzo" : {
			encdps : 1424.86,
			enchps : 0,
			enctps : 102.55,
		},
		"Lindsey Stirling" : {
			encdps : 1216.37,
			enchps : 0,
			enctps : 71.55,
		},
		Beedle : {
			encdps : 1118.97,
			enchps : 0,
			enctps : 119.43,
		},
		Uther : {
			encdps : 1030.99,
			enchps : 0,
			enctps : 105.72,
		},
		Ashor : {
			encdps : 970.12,
			enchps : 206.95,
			enctps : 131.83,
		},
		"Sigmund Freud" : {
			encdps : 572.91,
			enchps : 751.36,
			enctps : 83.09,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1083,
			enctps : 187.87,
		},
	},
	1596275604 : {
		Encounter : {
			encdps : 7834.7,
			enchps : 2344.91,
			enctps : 1090.76,
		},
		YOU : {
			encdps : 1500.48,
			enchps : 0,
			enctps : 164.44,
		},
		"Hattori Hanzo" : {
			encdps : 1424.86,
			enchps : 0,
			enctps : 142.6,
		},
		"Lindsey Stirling" : {
			encdps : 1216.37,
			enchps : 0,
			enctps : 91.21,
		},
		Beedle : {
			encdps : 1118.97,
			enchps : 0,
			enctps : 139.87,
		},
		Uther : {
			encdps : 1030.99,
			enchps : 0,
			enctps : 105.72,
		},
		Ashor : {
			encdps : 970.12,
			enchps : 206.95,
			enctps : 156.21,
		},
		"Sigmund Freud" : {
			encdps : 572.91,
			enchps : 861.26,
			enctps : 83.09,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1276.7,
			enctps : 207.61,
		},
	},
	1596275620 : {
		Encounter : {
			encdps : 6505.48,
			enchps : 2331.3,
			enctps : 967.74,
		},
		YOU : {
			encdps : 1235.2,
			enchps : 0,
			enctps : 149.66,
		},
		"Hattori Hanzo" : {
			encdps : 1187.46,
			enchps : 0,
			enctps : 117.39,
		},
		"Lindsey Stirling" : {
			encdps : 1019.75,
			enchps : 0,
			enctps : 75.08,
		},
		Beedle : {
			encdps : 930.29,
			enchps : 0,
			enctps : 129.25,
		},
		Uther : {
			encdps : 862.55,
			enchps : 0,
			enctps : 87.03,
		},
		Ashor : {
			encdps : 798.61,
			enchps : 170.36,
			enctps : 152.34,
		},
		"Sigmund Freud" : {
			encdps : 471.62,
			enchps : 733.75,
			enctps : 68.4,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1427.19,
			enctps : 188.59,
		},
	},
	1596275635 : {
		Encounter : {
			encdps : 6474.18,
			enchps : 2198.33,
			enctps : 907.57,
		},
		YOU : {
			encdps : 1180.15,
			enchps : 0,
			enctps : 140.35,
		},
		"Hattori Hanzo" : {
			encdps : 1170.72,
			enchps : 0,
			enctps : 110.09,
		},
		"Lindsey Stirling" : {
			encdps : 1024.94,
			enchps : 0,
			enctps : 70.41,
		},
		Beedle : {
			encdps : 942.11,
			enchps : 0,
			enctps : 121.21,
		},
		Uther : {
			encdps : 865.06,
			enchps : 0,
			enctps : 81.62,
		},
		Ashor : {
			encdps : 815.46,
			enchps : 171.75,
			enctps : 142.87,
		},
		"Sigmund Freud" : {
			encdps : 475.75,
			enchps : 688.12,
			enctps : 64.15,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1338.45,
			enctps : 176.87,
		},
	},
	1596275650 : {
		Encounter : {
			encdps : 6474.18,
			enchps : 2212.8,
			enctps : 926.39,
		},
		YOU : {
			encdps : 1180.15,
			enchps : 0,
			enctps : 142.77,
		},
		"Hattori Hanzo" : {
			encdps : 1170.72,
			enchps : 0,
			enctps : 112.6,
		},
		"Lindsey Stirling" : {
			encdps : 1024.94,
			enchps : 0,
			enctps : 72.92,
		},
		Beedle : {
			encdps : 942.11,
			enchps : 0,
			enctps : 123.68,
		},
		Uther : {
			encdps : 865.06,
			enchps : 0,
			enctps : 83.57,
		},
		Ashor : {
			encdps : 815.46,
			enchps : 171.75,
			enctps : 144.79,
		},
		"Sigmund Freud" : {
			encdps : 475.75,
			enchps : 695.93,
			enctps : 66.67,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1345.11,
			enctps : 179.39,
		},
	},
	1596275665 : {
		Encounter : {
			encdps : 6474.18,
			enchps : 2277.89,
			enctps : 1099.47,
		},
		YOU : {
			encdps : 1180.15,
			enchps : 0,
			enctps : 165.47,
		},
		"Hattori Hanzo" : {
			encdps : 1170.72,
			enchps : 0,
			enctps : 135.45,
		},
		"Lindsey Stirling" : {
			encdps : 1024.94,
			enchps : 0,
			enctps : 96.88,
		},
		Beedle : {
			encdps : 942.11,
			enchps : 0,
			enctps : 146.1,
		},
		Uther : {
			encdps : 865.06,
			enchps : 0,
			enctps : 101.03,
		},
		Ashor : {
			encdps : 815.46,
			enchps : 171.75,
			enctps : 162.42,
		},
		"Sigmund Freud" : {
			encdps : 475.75,
			enchps : 730.61,
			enctps : 90.35,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1375.53,
			enctps : 201.78,
		},
	},
	1596275680 : {
		Encounter : {
			encdps : 5572.69,
			enchps : 2287.73,
			enctps : 891.59,
		},
		"Hattori Hanzo" : {
			encdps : 1032.57,
			enchps : 0,
			enctps : 109.84,
		},
		YOU : {
			encdps : 988.26,
			enchps : 0,
			enctps : 134.18,
		},
		"Lindsey Stirling" : {
			encdps : 872.09,
			enchps : 0,
			enctps : 78.56,
		},
		Beedle : {
			encdps : 793.89,
			enchps : 0,
			enctps : 118.48,
		},
		Uther : {
			encdps : 747.72,
			enchps : 0,
			enctps : 81.92,
		},
		Ashor : {
			encdps : 731.26,
			enchps : 139.28,
			enctps : 131.71,
		},
		"Sigmund Freud" : {
			encdps : 406.9,
			enchps : 787.38,
			enctps : 73.27,
		},
		"Nicolaus Copernicus" : {
			encdps : 0,
			enchps : 1361.08,
			enctps : 163.63,
		},
	},
};

export default SampleHistoryData;
